







































import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import ImportMenu from './Components/ImportItem.vue';

@Component({
  components: {
      ImportMenu
  }
})
export default class NaigationButtonComponent extends Vue {
    @Prop() title!: any;
    @Prop() options!: Array<any>;

}
